let cachedAssetBaseUrl = null;

const stripTrailingSlash = (value) => value.replace(/\/+$/, '');

const deriveBaseFromApiUrl = (apiUrl, fallbackOrigin) => {
  if (!apiUrl) {
    return fallbackOrigin;
  }
  try {
    const parsed = new URL(apiUrl, fallbackOrigin || 'http://localhost');
    let pathname = parsed.pathname || '';
    pathname = stripTrailingSlash(pathname);
    if (/\/api(\/v\d+)?$/i.test(pathname)) {
      pathname = pathname.replace(/\/api(\/v\d+)?$/i, '');
    }
    return stripTrailingSlash(`${parsed.origin}${pathname && pathname !== '/' ? pathname : ''}`);
  } catch {
    return fallbackOrigin;
  }
};

export const getAssetBaseUrl = () => {
  if (cachedAssetBaseUrl !== null) {
    return cachedAssetBaseUrl;
  }

  const fallbackOrigin = typeof window !== 'undefined' ? window.location.origin : '';
  const explicit = (import.meta.env.VITE_ASSET_BASE_URL || '').trim();

  if (explicit) {
    try {
      const parsed = new URL(explicit, fallbackOrigin || 'http://localhost');
      cachedAssetBaseUrl = stripTrailingSlash(parsed.href);
      return cachedAssetBaseUrl;
    } catch {
      cachedAssetBaseUrl = stripTrailingSlash(explicit);
      return cachedAssetBaseUrl;
    }
  }

  const apiUrl = (import.meta.env.VITE_API_URL || '').trim();
  if (apiUrl) {
    cachedAssetBaseUrl = stripTrailingSlash(deriveBaseFromApiUrl(apiUrl, fallbackOrigin) || fallbackOrigin || '');
    return cachedAssetBaseUrl;
  }

  cachedAssetBaseUrl = stripTrailingSlash(fallbackOrigin || '');
  return cachedAssetBaseUrl;
};

export const resolveAssetUrl = (rawValue) => {
  if (rawValue === undefined || rawValue === null) {
    return null;
  }
  const value = String(rawValue).trim();
  if (!value) {
    return null;
  }
  const normalizedValue = value.replace(/\\/g, '/').replace(/^\.\//, '');
  const candidate =
    normalizedValue.startsWith('uploads/') || normalizedValue.startsWith('/uploads/')
      ? `/${normalizedValue.replace(/^\/+/, '')}`
      : normalizedValue;

  try {
    const direct = new URL(candidate);
    return direct.href;
  } catch {
    if (/^https?:\/\//i.test(candidate)) {
      return candidate;
    }
    if (candidate.startsWith('//')) {
      const protocol = typeof window !== 'undefined' ? window.location.protocol : 'https:';
      return `${protocol}${candidate}`;
    }
    const base = getAssetBaseUrl();
    if (!base) {
      return candidate;
    }
    if (candidate.startsWith('/')) {
      return `${base}${candidate}`;
    }
    return `${base}/${candidate}`;
  }
};
